"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const customization_context_1 = require("../../shared/customization-context");
const Link = ({ children, ...props }) => {
    const { onNavigateToType } = (0, customization_context_1.useCustomizationSettings)();
    const onClick = (event) => {
        if (onNavigateToType) {
            event.preventDefault();
            onNavigateToType(props.href ?? "no href provided to link");
        }
        props.onClick?.(event);
    };
    const onKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            if (onNavigateToType) {
                event.preventDefault();
                onNavigateToType(props.href ?? "no href provided to link");
            }
        }
        props.onKeyDown?.(event);
    };
    return ((0, jsx_runtime_1.jsx)("a", { ...props, onClick: onClick, onKeyDown: onKeyDown, role: "link", tabIndex: props.tabIndex ?? 0, children: children }));
};
exports.Link = Link;
